import { UnleashClient } from "@unleash/proxy-client-vue";

const unleashClient = new UnleashClient({
  url: import.meta.env.VITE_APP_UNLEASH_URL,
  clientKey: import.meta.env.VITE_APP_UNLEASH_PROXY_SECRETS,
  appName: import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV,
  disableRefresh: false,
  refreshInterval: 0,
  disableMetrics: true,
  metricsInterval: 0,
});

let lastSyncedUnleashUserId = null;

export const syncUnleashUserContext = async (updateContext, userId) => {
  if (!userId || typeof updateContext !== "function") {
    return false;
  }

  if (lastSyncedUnleashUserId === userId) {
    return false;
  }

  await updateContext({ userId });
  lastSyncedUnleashUserId = userId;
  return true;
};

export const resetSyncedUnleashUserContext = () => {
  lastSyncedUnleashUserId = null;
};

export default unleashClient;
